import React, { useEffect, useState } from "react";
import {
  Grid,
  TextField,
  Select,
  MenuItem,
  Typography,
  Box,
  Button,
  ToggleButtonGroup,
  ToggleButton,
  SelectChangeEvent,
  DialogTitle,
  IconButton,
  DialogContent,
  DialogActions,
  Dialog,
  FormLabel,
} from "@mui/material";
import { Search } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import AddLocationTable from "./addLocationtable";
import AddLocationDialog1 from "./addlocationdialog";
import AddLocationIcon from "@mui/icons-material/AddLocation";
import { axiosInstance } from "../../../utils/tokenSetCookie";
import Close from "@mui/icons-material/Close";
import { toast } from "react-toastify";
import {
  LocationClassList,
  LocationListData,
  EditLocationData,
  UserDetails,
} from "../../../types/types";
import LoginRestriction from "../../../utils/loginRestriction";
import { AxiosError } from "axios";
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

const ManageLocation = () => {
  const { t } = useTranslation();
  const [locationClassName, setLocationClassName] = useState<string>("-1");
  const [deletedList, setDeletedList] = useState<string>("false");
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [dialogMode, setDialogMode] = useState<"add" | "edit">("add");
  const [eligibleLocation, _setEligibleLocation] = useState(0);

  // Api call state
  const [locationName, setLocationName] = useState<string>("");
  const [locationClassLists, setLocationClassLists] = useState<
    LocationClassList[]
  >([]);
  const [locationDataLists, setLocationDataLists] = useState<
    LocationListData[]
  >([]);
  const [locationStatus, setLocationStatus] = useState("false");
  const [locationEditData, setLocationEditData] =
    useState<EditLocationData | null>(null);
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const [isDeletedLocation, setDeletedLocation] = useState(0);
  const [userDetails, setUserDetails] = useState<UserDetails | null>(null);

  // Add this state near other state declarations
  const [isCallbackDialogOpen, setIsCallbackDialogOpen] = useState(false);
  const [isRestrictionOpen, setIsRestrictionOpen] = useState(false);

  const [loading, setLoading] = useState(false);

  // Simulate a 3-second loading period
  useEffect(() => {
    if (loading === true) {
      const timer = setTimeout(() => {
        setLoading(false);
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [loading]);

  // Getting location lists
  useEffect(() => {
    const getUserDetail = async () => {
      try {
        const response = await axiosInstance.get(
          API_BASE_URL + "users/getuserdetails"
        );
        if (response.status >= 200 && response.status <= 300) {
          setUserDetails(response.data.data); // Save data to state
        }
      } catch (error) {
        const errCode = error as AxiosError<{ status: number }>;
        if (errCode.response && errCode.response.status === 401) {
          setIsRestrictionOpen(true);
        } else {
          toast.error("Something went wrong", {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
          });
        }
        throw error;
      }
    };
    getUserDetail(); // Passing the payload as an argument
  }, []);
  // // Getting location lists

  // Getting location lists and location class lists when component mounts. Using Promise.all() If this not needed above useEffect will work
  useEffect(() => {
    const fetchData = async () => {
      try {
        const [locationResponse, classResponse] = await Promise.all([
          axiosInstance.get(API_BASE_URL + "location/list/"),
          axiosInstance.get(API_BASE_URL + "locationclass/list"),
        ]);
        if (locationResponse.status >= 200 && locationResponse.status <= 300) {
          setLocationDataLists(locationResponse.data.data);
        }
        if (classResponse.status >= 200 && classResponse.status <= 300) {
          setLocationClassLists(classResponse.data.data);
        }
      } catch (error) {
        const errCode = error as AxiosError<{ status: number }>;
        if (errCode.response && errCode.response.status === 401) {
          setIsRestrictionOpen(true);
        } else {
          toast.error("Something went wrong", {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
          });
        }
        throw error;
      }
    };
    fetchData();
  }, []);

  // Getting location lists when locationStatus is changed
  useEffect(() => {
    if (locationStatus === "true") {
      getLocationListData(); // Call function only when locationStatus is "true"
      setLocationStatus("false");
    }
  }, [locationStatus]); // Runs when locationStatus changes

  // Getting location lists when deleted list is changed
  useEffect(() => {
    handleSearch();
  }, [deletedList]);

  // Handle location class change event
  const handleLocationClassChange = (e: SelectChangeEvent) => {
    setLocationClassName(e.target.value);
  };
  // Getting location lists when locationStatus is changed
  const getLocationListData = async () => {
    // const getUpdatedListData = async () => {
    try {
      const response = await axiosInstance.get(API_BASE_URL + "location/list/");
      if (response.status >= 200 && response.status <= 300) {
        setLocationDataLists(response.data.data); // Save data to state
      }
    } catch (error) {
      const errCode = error as AxiosError<{ status: number }>;
      if (errCode.response && errCode.response.status === 401) {
        setIsRestrictionOpen(true);
      } else {
        toast.error("Something went wrong", {
          position: "top-right",
          autoClose: 1000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: false,
          draggable: false,
          progress: undefined,
        });
      }
      throw error;
    }
    // };
  };

  // Handle deleted list change event in Toggle button
  const handleChange = (
    _event: React.MouseEvent<HTMLElement>,
    newAlignment: string | null
  ) => {
    if (newAlignment !== null) {
      setDeletedList(newAlignment);
    }
  };

  // Handle dialog open and close
  // const handleOpenDialog = (mode: "add" | "edit") => {
  //   setDialogMode(mode);
  //   setIsDialogOpen(true);
  // };
  const handleCloseDialog = () => {
    setIsDialogOpen(false);
    setLocationEditData(null);
    // setSelectedLocation(null);
  };
  // Handle delete dialog
  const closeDeleteDialog = () => {
    setIsDeleteDialogOpen(false);
  };

  const handleEdit = async (locationId: number) => {
    try {
      const response = await axiosInstance.get(
        `${API_BASE_URL}location/${locationId}`
      );
      if (response.status >= 200 && response.status <= 300) {
        setLocationEditData(response.data.data);
        setDialogMode("edit");
        setIsDialogOpen(true);
      }
    } catch (error) {
      const errCode = error as AxiosError<{ status: number }>;
      if (errCode.response && errCode.response.status === 401) {
        setIsRestrictionOpen(true);
      } else {
        toast.error("Something went wrong", {
          position: "top-right",
          autoClose: 1000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: false,
          draggable: false,
          progress: undefined,
        });
      }
      throw error;
    }
  };

  // Handle delete dialog
  const handleDelete = (locationId: number) => {
    setIsDeleteDialogOpen(true);
    setDeletedLocation(locationId);
  };

  // Delete location data by id function
  const DeleteLocationData = async (locationDelete: number) => {
    // handleOpenDialog("edit", location);
    const payload = {
      id: locationDelete,
    };
    try {
      const response = await axiosInstance.put(
        API_BASE_URL + "location/delete",
        payload
      );
      if (response.status >= 200 && response.status <= 300) {
        setIsDeleteDialogOpen(false);
        setLocationDataLists((prev) =>
          prev.filter((loc) => loc.id !== locationDelete)
        );
        return toast.success("Location deleted successfully!", {
          autoClose: 500,
        });
      }
    } catch (error) {
      const errCode = error as AxiosError<{ status: number }>;
      if (errCode.response && errCode.response.status === 401) {
        setIsRestrictionOpen(true);
      } else {
        toast.error("Something went wrong", {
          position: "top-right",
          autoClose: 1000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: false,
          draggable: false,
          progress: undefined,
        });
      }
      throw error;
    }
  };

  // Handle search function for location
  const handleSearch = async () => {
    // Conditions based on search location details
    const endPoint =
      locationClassName === "-1" && deletedList === "true"
        ? `?deletedOn=true&locationName=${locationName}`
        : locationClassName === "-1" && deletedList === "false"
          ? `?locationName=${locationName}`
          : locationClassName.toString() !== "-1"
            ? deletedList === "true"
              ? `?deletedOn=${deletedList}&locationName=${locationName}&classId=${locationClassName}`
              : `?locationName=${locationName}&classId=${locationClassName}`
            : "";
    try {
      const response = await axiosInstance.get(
        API_BASE_URL + `location/list/${endPoint}`
      );
      if (response.status >= 200 && response.status <= 300) {
        setLocationDataLists(response.data.data);
        setLoading(true);
      }
    } catch (error) {
      const errCode = error as AxiosError<{ status: number }>;
      if (errCode.response && errCode.response.status === 401) {
        setIsRestrictionOpen(true);
      } else {
        toast.error("Something went wrong", {
          position: "top-right",
          autoClose: 1000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: false,
          draggable: false,
          progress: undefined,
        });
      }
      throw error;
    }
  };

  // Add these handlers before the return statement
  const handleOpenCallbackDialog = () => {
    if (!eligibleLocation) {
      setIsCallbackDialogOpen(true);
    } else {
      setIsDialogOpen(true);
    }
  };

  const handleCloseCallbackDialog = () => {
    setIsCallbackDialogOpen(false);
  };

  const handleRequestCallback = () => {
    toast.success(t("callback_request_submitted"));
    setIsCallbackDialogOpen(false);
  };


  return (
    <>
      <Box>
        {/* <ToastContainer /> */}
        <Box
          sx={{
            backgroundColor: "#fff",
            borderRadius: "12px",
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            margin: {
              xs: "10px 8px",
              sm: "15px 15px",
              md: "20px 20px",
            },
            overflow: "hidden",
          }}
        >
          <Typography
            variant="h5"
            sx={{
              borderBottom: "1px solid #eee",
              padding: "20px 24px",
              fontWeight: 600,
              color: "primary.main",
            }}
          >
            {t("manage_locations")}
          </Typography>

          <form>
            <Grid
              container
              spacing={3}
              sx={{
                padding: { xs: 2, sm: 3 },
                "& .MuiFormLabel-root": {
                  marginBottom: 1,
                  color: "text.secondary",
                  fontWeight: 500,
                },
              }}
            >
              {/* Form fields */}
              <Grid item xs={12} md={6}>
                <FormLabel>{t("business_entity")}</FormLabel>
                <TextField
                  value={userDetails?.businessName || ""}
                  size="small"
                  variant="outlined"
                  fullWidth
                  sx={{
                    backgroundColor: "#f8f9fa",
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "8px",
                    },
                  }}
                  InputProps={{ readOnly: true }}
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <FormLabel>{t("location_class_name")}</FormLabel>
                <Select
                  value={locationClassName || "-1"}
                  onChange={handleLocationClassChange}
                  size="small"
                  fullWidth
                  sx={{
                    borderRadius: "8px",
                    backgroundColor: "#fff",
                  }}
                >
                  <MenuItem value="-1">-- All --</MenuItem>
                  {locationClassLists.map((location) => (
                    <MenuItem key={location.id} value={location.id}>
                      {location.className}
                    </MenuItem>
                  ))}
                </Select>
              </Grid>

              <Grid item xs={12} md={6}>
                <FormLabel>{t("class_name")}</FormLabel>
                <TextField
                  value={locationName || ""}
                  onChange={(e) => setLocationName(e.target.value)}
                  size="small"
                  variant="outlined"
                  fullWidth
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "8px",
                    },
                  }}
                />
              </Grid>

              <Grid item xs={12} md={6} sx={{ mt: 3 }}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    flexWrap: "wrap",
                    gap: 2,
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                    <ToggleButtonGroup
                      color="primary"
                      value={deletedList}
                      exclusive
                      onChange={handleChange}
                      size="small"
                      sx={{
                        "& .MuiToggleButton-root": {
                          borderRadius: "6px",
                          px: 3,
                          "&.Mui-selected": {
                            backgroundColor: "primary.main",
                            color: "white",
                          },
                        },
                      }}
                    >
                      <ToggleButton value="true">{t("on")}</ToggleButton>
                      <ToggleButton value="false">{t("off")}</ToggleButton>
                    </ToggleButtonGroup>
                    <Typography sx={{ color: "text.secondary" }}>
                      {t("view_deleted")}
                    </Typography>
                  </Box>

                  <Button
                    variant="contained"
                    startIcon={<Search />}
                    onClick={handleSearch}
                    sx={{
                      textTransform: "none",
                      borderRadius: "8px",
                      px: 3,
                    }}
                  >
                    {t("search")}
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </form>
        </Box>

        {/* Second section - Table */}
        <Box
          sx={{
            backgroundColor: "#fff",
            borderRadius: "12px",
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            margin: {
              xs: "10px 8px",
              sm: "15px 15px",
              md: "20px 20px",
            },
            padding: { xs: 1.5, sm: 2 },
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              mb: 3,
            }}
          >
            {/* Left Side Button */}
            <Box
              sx={{
                backgroundColor: eligibleLocation ? "#1976d2" : "#ababab",
                padding: "7px",
                borderRadius: "5px",
                color: "#fff",
              }}
            >
              {eligibleLocation ? (
                <Typography>
                  You are eligible to create up to {eligibleLocation}{" "}
                  {eligibleLocation === 1 ? "location" : "locations"}.
                </Typography>
              ) : (
                <Typography>
                  Location limit reached. Please upgrade your plan to add more
                  locations
                </Typography>
              )}
            </Box>

            {/* Right Side Button */}
            <Box>
              <Button
                variant="contained"
                startIcon={<AddLocationIcon />}
                onClick={handleOpenCallbackDialog}
                sx={{
                  textTransform: "none",
                  borderRadius: "8px",
                  px: 3,
                }}
              >
                {t("add_location")}
              </Button>
            </Box>
          </Box>

          <Box
            sx={{
              border: "1px solid #eee",
              borderRadius: "8px",
              overflow: "hidden",
            }}
          >
            <AddLocationTable
              locationData={locationDataLists}
              onEdit={handleEdit}
              onDelete={handleDelete}
            />
          </Box>
        </Box>

        {/* Dialog */}
        <AddLocationDialog1
          isOpen={isDialogOpen}
          onClose={handleCloseDialog}
          mode={dialogMode}
          setStatus={setLocationStatus}
          editData={locationEditData}
        />

        {/* Delete Confirmation Dialog */}
        <Dialog
          open={isDeleteDialogOpen}
          onClose={handleCloseDialog}
          sx={{
            "& .MuiDialog-paper": {
              width: { xs: "90%", sm: "600px" }, // Responsive dialog width
              maxWidth: "100%",
            },
          }}
        >
          <DialogTitle className="dialogtitle">
            <Typography>{t("are_you_sure")}</Typography>
            <IconButton
              edge="end"
              color="inherit"
              onClick={closeDeleteDialog}
              aria-label="close"
              sx={{
                margin: "auto",
                position: "absolute",
                right: "25px",
                top: "17px",
                width: "30px",
                height: "30px",
                borderRadius: "50%",
                border: "1px solid #be1e2d", // Red border
                color: "#be1e2d", // Default text color
                "&:hover": {
                  backgroundColor: "#be1e2d", // Full red background on hover
                  color: "#ffffff", // White icon color
                },
              }}
            >
              <Close />
            </IconButton>
          </DialogTitle>
          <DialogContent sx={{ marginTop: 2 }}>
            <Typography>
              {t("total_associated_locations")}: 0<br />
              {t("total_associated_users")}: 0
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={closeDeleteDialog} className="cancelbtn">
              {t("no")}
            </Button>

            <Button
              color="primary"
              variant="contained"
              onClick={() => DeleteLocationData(isDeletedLocation)}
              className="addbtn"
              // onClick={DeleteLocationData} // Call the delete function
            >
              {t("yes")}
            </Button>
          </DialogActions>
        </Dialog>

        {/* Add this dialog component before the closing Box tag */}
        <Dialog
          open={isCallbackDialogOpen}
          onClose={handleCloseCallbackDialog}
          sx={{
            "& .MuiDialog-paper": {
              width: { xs: "90%", sm: "500px" },
              maxWidth: "100%",
              borderRadius: "12px",
            },
          }}
        >
          <DialogTitle
            sx={{
              pb: 1,
              borderBottom: "1px solid #eee",
            }}
          >
            <Typography variant="h6" sx={{ fontWeight: 600 }}>
              {t("add_multiple_clinics")}
            </Typography>
            <IconButton
              edge="end"
              color="inherit"
              onClick={handleCloseCallbackDialog}
              aria-label="close"
              sx={{
                position: "absolute",
                right: "25px",
                top: "17px",
                border: "1px solid #be1e2d",
                color: "#be1e2d",
                width: "30px",
                height: "30px",
                borderRadius: "50%",
                "&:hover": {
                  backgroundColor: "#be1e2d",
                  color: "#ffffff",
                },
              }}
            >
              <Close />
            </IconButton>
          </DialogTitle>
          <DialogContent sx={{ pt: 3 }}>
            <Typography>
              <br />
              {t(
                "You have reached your current location limit. To enable additional locations, an upgrade is required."
              )}
            </Typography>
          </DialogContent>
          <DialogActions sx={{ p: 2.5, gap: 1 }}>
            <Button
              onClick={handleCloseCallbackDialog}
              variant="outlined"
              sx={{
                borderRadius: "8px",
                textTransform: "none",
                minWidth: "100px",
              }}
            >
              {t("cancel")}
            </Button>
            <Button
              onClick={handleRequestCallback}
              variant="contained"
              sx={{
                borderRadius: "8px",
                textTransform: "none",
                minWidth: "150px",
              }}
            >
              {t("buy_location")}
            </Button>
          </DialogActions>
        </Dialog>
      </Box>
      <LoginRestriction open={isRestrictionOpen} />
    </>
  );
};

export default ManageLocation;
